module.exports = __webpack_public_path__ + "img/icon_foxone.7a3ec00c.png";